import { Link } from "react-router-dom";
import gelatinaBg from "../assets/images/fondoGELATINA220.png";

const WHATSAPP_NUMBER = "51994692096";

function waLink(message) {
  return `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;
}

export default function Home() {
  return (
    <main className="bg-white">
      {/* HERO full width (imagen de fondo) */}
      <section className="relative h-[86vh] min-h-[640px] w-full overflow-hidden">
        {/* Fondo */}
        <img
          src={gelatinaBg}
          alt="Gelatina industrial Cardin"
          className="absolute inset-0 h-full w-full object-cover"
        />

        {/* Overlay MUY suave (casi nada) */}
        <div className="absolute inset-0 bg-gradient-to-b from-black/0 via-black/0 to-transparent" />
        <div className="absolute inset-0 bg-[radial-gradient(circle_at_50%_0%,rgba(253,230,138,0.16),transparent_65%),radial-gradient(circle_at_100%_15%,rgba(186,230,253,0.16),transparent_60%)]" />

        {/* Contenido encima */}
        <div className="relative z-10 mx-auto flex h-full max-w-6xl flex-col items-center justify-start px-6 pt-24 md:pt-32 lg:pt-7 text-center">
          <h1 className="mt-4 text-5xl md:text-7xl font-semibold tracking-tight text-slate-900">
            Gelatina comestible
          </h1>

          <p className="mt-3 max-w-2xl text-lg md:text-xl text-slate-700">
            Bloom 220 y 250 para formulaciones exigentes.
          </p>

          {/* Botones */}
          <div className="mt-2 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/gelatinas"
              className="rounded-full bg-blue-600 px-6 py-3 text-[14px] font-medium text-white shadow-sm transition hover:bg-blue-700 active:scale-[0.99]"
            >
              Más información
            </Link>

            <a
              href={waLink("Hola, deseo comprar/cotizar Gelatina. Bloom: __. Cantidad: __ kg. Ciudad: __.")}
              target="_blank"
              rel="noreferrer"
              className="rounded-full border border-blue-600/40 bg-white/70 px-6 py-3 text-[14px] font-medium text-blue-700 shadow-sm backdrop-blur transition hover:bg-white active:scale-[0.99]"
            >
              Comprar por WhatsApp
            </a>
          </div>
        </div>
      </section>

      
    </main>
  );
}
